import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { QuoteNumberArea } from "./Styles";

export default function Quote({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const {
    document,
    document: {
      documents: {
        quote: { number },
      },
    },
  } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Cotización"
            value={!value ? (!number ? document.docNumber : number) : value}
          />
        </div>
      ) : (
        <QuoteNumberArea>
          <Informative
            readonly={true}
            label="Cotización"
            value={!value ? (!number ? document.docNumber : number) : value}
          />
        </QuoteNumberArea>
      )}
    </>
  );
}
